








































import BaseTlTable from "./BaseTLTable.vue";
import { Vue, Component, Prop  } from "../../Infrastructure/CorBase/CoreBase";

			@Component
			export default class BaseTLModalDialogTreeView extends Vue { 

				@Prop({ type: String, required: true, default: null }) title?: string;
				@Prop({ required: true }) itemsData: any; //zakladni datova napln
				@Prop({ type: String, required: true, default: "" }) id!: string;

				readonly = false;  //tohle parametr
				type = "type";
				idUser = "";
				idRole = "";

				children: any[] = [];
				//name = "";
				typeSelected = "-1";
				detail = false;
				dataTree = {
					name: 'Groups',
					notEdit: true,
					root: true,
					children: this.children
				};

				changeData: {
					isSelected: boolean,
					idRole: number,
					idUser: number,
					idGroup: number
				}[] = [];

				createChangeData(selected: boolean, role: number, user: number, group: number) {
					return {
						isSelected: selected,
						idRole: role,
						idUser: user,
						idGroup: group
					}
				}
				
				prepareData() {

					let treeData = {
						name: 'Groups',
						notEdit: true,
						root: true,
						children: this.children
					}
					return treeData;
				}

				preparedChildren(items: any[]) {

					if (this.children.length == 0) {

						let listAll = items;
						let forChildren: any[] = [];
						let continueNode: any[] = [];

						let isExistChild = true;
						while (isExistChild) {
							isExistChild = false;
							continueNode.length = 0;
							forChildren.length = 0;

							for (var item of listAll) {
								if (item.children == undefined) {
									item.children = [];
								}
								let existuje = listAll.find(c => c.idGroup == item.id && c.id != c.idGroup);
								if (existuje == null && item.idGroup != null && item.id != item.idGroup) {
									isExistChild = true;
									forChildren.push(this.prepareItem(item));
								}
								else {
									continueNode.push(this.prepareItem(item)); //pokračuje k dalsimu zpracovani							
								}
							}

							listAll.length = 0;
							for (var item of continueNode) {

								for (var child of forChildren) {
									if (child.idGroup == item.id) {
										item.children.push(this.prepareItem(child));
									}
								}
								listAll.push(this.prepareItem(item));
							}
						}
						this.children = listAll;
					}
				}

				prepareItem(item: any) {
					var selected = item.selected;
					return { id: item.id, selected: selected, name: item.name, idGroup: item.idGroup, children: item.children, description: item.description };
				}

				groups: any[] = [];

				public init(items: any, idUser: any, idRole: any): void {
					this.idUser = idUser;
					this.idRole = idRole;

					this.children = [];
					this.groups = items;
					//DOCASNE PRYC
					//for (var item of this.groups) {
					//	let parentItem = (this.groups.filter(c => c.id == item.idGroup)[0]);
					//	if (parentItem != undefined) {
					//		nameParent = parentItem.name;
					//	}
					//}
					this.preparedChildren(items);
					this.dataTree = {
						name: 'GroupsXXX',
						notEdit: false,
						root: false,
						children: this.children
					};
					this.dataTree = this.prepareData();
				}

				dataLoad() {
					return this.dataTree;
				}

				showFilterSettings(): void {
					(this.$refs.tableModal as BaseTlTable).showFilterSettings();
				}

				useSelected(selected: any): void {
			  	this.$emit('selected', selected);
					this.$bvModal.hide(this.id);
				}

				selectedItems = '';
				notSelectedItems = '';
				//zjištění všech zatržených bodů
				prepareDataForSave(item: any) {

					for (var i = 0; i < item.children.length; i++) {
						this.prepareDataForSave(item.children[i]);
					}
					if (item.selected) {
						this.changeData.push(((this.createChangeData(true, Number(this.idRole), Number(this.idUser), item.id))));
						this.selectedItems = this.selectedItems + item.id + '|';
					}
					if (!item.selected) {
						this.changeData.push(((this.createChangeData(false, Number(this.idRole), Number(this.idUser), item.id))));
						this.notSelectedItems = this.notSelectedItems + item.id + '|';
					}
					return true;
				}

				private save(): void {

					this.selectedItems = '';
					this.notSelectedItems = '';
					this.changeData = [];
					this.prepareDataForSave(this.dataTree);
					this.$bvModal.hide(this.id);
					this.$emit('changeData', this.changeData);
				}

				close(): void {
					this.$bvModal.hide(this.id);
				}
}

